module.exports = __webpack_public_path__ + "img/uni_tik_logo.c74b6fa7.png";